export const categoryKeys = {
  "drug": "药品",
  "labtest": "化验项目",
  "exam": "检查收费",
  "operation": "手术收费",
  "careservice": "护理服务",
  "oppointment": "预约挂号",
  "lens": "镜片",
  "frame": "镜框",
  "glasses": "成品眼镜",
  "contactglass": "SCL",
  "visualtrain": "视觉训练",
  "care": "保健品",
  "equipment": "器械",
  "studyresource": "学习资料",
  "accessories": "配件",
  "material": "耗材",
  "treatment": "治疗收费",
  "ametropia": "屈光不正治疗",
  "oklens": "OK镜",
  "rgp": "RGP",
  "iol": "晶体",
  "maintenance": "维修",
  "orther": "其它",
  "topeye": "在线视觉训练",
  "onlinetrain": "在线训练",
  "marketactivity": "营销活动",
  "ci": "积分"
}